/* eslint-disable @nx/enforce-module-boundaries */
import { Button, Card, HStack, Spinner, Stack, Text } from '@mybridge/ui';
import { useRouter } from 'next/router';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { SuggestedJobCard } from 'v4/components/jobs/suggested-job-card';
import { JobNotFoundIllustration } from '../404';
import { JobsListingContext } from '../context';
import { useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { isMobile } from 'react-device-detect';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const SuggestedJobsListing = forwardRef(({ ...props }, ref) => {
  const {
    suggestedJobsListing,
    refetchSuggestedJobsListing,
    suggestedJobsListingisFetching,
    searchJobsListingIsFetching,
    suggestedJobsListingIsFetching,
    fetchSuggestedJobsListingNextPage,
    suggestedJobsListingHasNextPage,
    suggestedJobsListingCount,
    saveJob,
    saveJobIsLoading,
    savedJobsListing,
    refetchSavedJobsListing,
    removeSavedJob,
    removeSavedJobIsLoading,
    setAppliedJob,
    applyDisc,
    appliedJobsListing,
    isSavedJob,
    isAppliedJob,
  } = useContext(JobsListingContext);
  const { userProfileInfo } = useSelector((s) => s?.userProfile);
  const [selected, setSelected] = useState();
  const { push } = useRouter();
  const { t } = useTranslator();
  const { pathname } = useRouter();
  const userSlug = userProfileInfo?.slug || 'anonymous';
  useEffect(() => {
      if(pathname ==='/jobs/suggested'){
        trackEvent(ANALYTICS_EVENTS.SuggestedJobs, userSlug);
      }
    },[pathname,userSlug]);
  // useEffect(() => {
  //   refetchSuggestedJobsListing?.();
  //   refetchSavedJobsListing?.();
  // }, []);

  if (suggestedJobsListingisFetching)
    return (
      <HStack justifyContent="center" py={12}>
        <Spinner />
      </HStack>
    );

  return (
    <Stack>
      {suggestedJobsListing?.length > 0 ? (
        <Stack px={[2, 0]} w="100%">
          <Text mb={4}>
            {t('jobs.jobRecommendationsInfo') || "Below are other jobs you might like, based on your resume, prior job applications and search history."}
          </Text>

          <InfiniteScroll
            dataLength={suggestedJobsListingCount}
            next={fetchSuggestedJobsListingNextPage}
            hasMore={!!suggestedJobsListingHasNextPage}
            loader={
              <HStack p={4} justifyContent="center" w="100%">
                <Spinner />
              </HStack>
            }
          >
            <HStack alignItems="stretch" spacing={0} flexWrap="wrap" gap={5} paddingBottom= "100px">
              {suggestedJobsListing
                ?.filter?.(
                  (job) =>
                    job?.id &&
                    // job?.status !== 'Closed' &&
                    job?.created_by !== userProfileInfo?.email
                )
                ?.map((job, jobIndex) => {
                  const saved = isSavedJob(job?.id);
                  const applied = isAppliedJob(job?.id);
                  return (
                    <Card
                    h={!isMobile?"290px":"auto"}
                      w={['100%', '100%', '48.2%']}
                      jobIndex={jobIndex}
                      p={4}
                      key={jobIndex}
                      border="1px solid #D4D4D4"
                      borderRadius="20px"
                      //boxShadow="none"
                      boxShadow="md"
                    >
                      <SuggestedJobCard
                        href={'/jobs/' + job?.id}
                        onViewDetailsClick={(e) => push('/jobs/' + job?.id)}
                        onSaveClick={(e) => {
                          setSelected(job);
                          saved
                            ? removeSavedJob(saved)
                            : saveJob({ job_id: job?.id });
                        }}
                        job={job}
                        saveLoading={
                          selected?.id === job?.id &&
                          (saveJobIsLoading || removeSavedJobIsLoading)
                        }
                        onApplyClick={(e) => {
                          if (
                            typeof window !== 'undefined' &&
                            job?.how_to_apply === 'EXTERNAL'
                          ) {
                            window.open(job?.how_to_apply_text, '_blank');
                          } else {
                            setAppliedJob?.(job);
                            applyDisc?.onOpen?.();
                          }
                        }}
                        isSaved={saved}
                        isApplied={applied}
                      />
                    </Card>
                  );
                })}
            </HStack>
          </InfiniteScroll>

          {/* {suggestedJobsListingHasNextPage ? (
            <Button
              onClick={fetchSuggestedJobsListingNextPage}
              variant="secondary"
            >
              Load More
            </Button>
          ) : (
            ''
          )} */}
        </Stack>
      ) : suggestedJobsListingIsFetching ? (
        <Stack alignItems="center" justifyContent="center" pt="20">
          <SectionLoader/>
        </Stack>
      ): !suggestedJobsListingIsFetching && (
        <Stack alignItems="center" justifyContent="center" pt="20">
          <JobNotFoundIllustration />
          <Text>
            You do not have any suggested jobs.
          </Text>
        </Stack>
      )}
    </Stack>
  );
});
